import { render } from "./ArchiveOrders.vue?vue&type=template&id=26b1ebe6"
import script from "./ArchiveOrders.vue?vue&type=script&lang=js"
export * from "./ArchiveOrders.vue?vue&type=script&lang=js"

import "./ArchiveOrders.vue?vue&type=style&index=0&id=26b1ebe6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/ArchiveOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26b1ebe6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26b1ebe6', __exports__)) {
    console.log('reload')
    api.reload('26b1ebe6', __exports__)
  }
  
  module.hot.accept("./ArchiveOrders.vue?vue&type=template&id=26b1ebe6", () => {
    console.log('re-render')
    api.rerender('26b1ebe6', render)
  })

}


export default __exports__